export const routes = {
  // provider
  providerIndex: "/provider/dashboard",

  addVideo: "/provider/add-video",
  addVideoNew: "/provider/add-video-new",
  analytics: "/provider/analytics",
  financialPerformance: "/provider/financial-performance-v2",
  announcements: "/provider/announcements",
  addAnnouncements: "/provider/add-announcements",
  editAnnouncements: "/provider/edit-announcements",
  manageVideos: "/provider/manage-videos",
  notifications: "/provider/notifications",
  profilePerformance: "/provider/profile-performance-table",
  providerProfile: "/provider/provider-profile",
  review: "/provider/review",
  generatereviewlink: "/provider/generate-review-link",
  videoPerformance: "/provider/video-performance",
  writtenContent: "/provider/written-content",
  writtenPerformance: "/provider/written-performance",
  goLive: "/provider/go-live",
  calendar: "/provider/calendar",
  earning: "/provider/earning",
  goLiveNow: "/provider/golive-now",
  featuredWordWideFeed: "/provider/featured-world-wide-feed",
  scheduleStream: "/provider/schedule-stream",
  settings: "/provider/settings",
  events: "/provider/events",
  embedWidget: "/provider/embed-widget",
  directory: "/provider/directory",
  billing: "/provider/billing-details",
  scheduleWorldwideStream: "/provider/schedule-worldwide-stream",
  wallet: "/provider/wallet",
  chat: "/provider/chat",
  privatechat: "/provider/chat-private",
  allAnnoncement: "/provider/all-annocement",
  providerInfo: "/provider/providerdirectory",
  mysubscriptionProvider: "/provider/my-subscription",
  mysubscribersProvider: "/provider/subscribers-followers",
  walletnew: "/provider/wallet-new",
  walletadd: "/provider/wallet",
  profileEdit: "/provider/profile-edit",
  addCampaign: "/provider/add-campaign",
  editCampaign: "/provider/edit-campaign",
  addAds: "/provider/add-ads",
  addBid: "/provider/add-bid",
  campaigns: "/provider/campaigns",
  campaignViewList: "/provider/campaignListView",
  advertisementDashboard: "/provider/advertisement-dashboard",
  MyEarning: "/provider/my-earning",
  AdvertisementBilling: "/provider/advertisement-billing",
  monetization: "/provider/monetization",
  addMonetization: "/provider/monetization/add",
  editMonetization: "/provider/monetization/edit",
  viewMonetization: "/provider/monetization/detail",
  // locationModal: "/provider/location-modal",

  //provider version 2 screens
  providerDashboard: "/provider/dashboard-v2",
  providerpageFeed: "/page-feed",
  clientPageFeed: "/client-page-feed",
  addVideov2: "/provider/add-video-v2",
  goLiveV2: "/provider/golive-v2",
  goLiveNowV2: "/provider/live-now-v2",
  schudleStreamV2: "/provider/schudle-stream-v2",
  addAnnoncementV2: "/provider/add-annoncement-v2",
  writtenSubmssionRequest: "/provider/submisson-request",
  writtentRevisionsrequeste: "/provider/revision-request",
  writtenContentAnalaytics: "/provider/content-analaytics",
  myWrittenContent: "/provider/my-writtencontent",
  favoriteContent: "/provider/content-favorite",
  externalReview: "/external-review",
  eventsv2: "/provider/events",
  recommandedEventV2: "/provider/recommended-events",
  eventsLive: "/events-live",
  managevideoV1: "/provider/manage-video-v1",
  videoanalytics: "/provider/video-analytics",
  myAccount: "/provider/my-account",
  writtentRevisionsrequestedit: "/provider/revision-request-edit",
  subscriptionPlan: "/provider/subscriptionplan",
  transactionHistory: "/provider/transactionhistory",
  providderaccountSettings: "/provider/accountsettings",
  providerMySubscription: "/provider/my-subscriptions",
  profileperformanceLeadTrack: "/provider/lead-track",
  contactEnquiries: "/provider/contact-enquiries",
  myNetwork: "/provider/mynetwork",
  eventPerformance: "/provider/event-performance",
  taxform: "/provider/tax-forms",
  financialPerformanceV2: "/provider/financial-performance",
  chatnew: "/provider/chat-v2",
  eventAnalytics: "/provider/event-analytics",
  videoPerformanceV2: "/provider/video-performance-v2",
  profilePerformanceOverview: "/provider/profile-performance",
  profileBoosting: "/provider/profile-boosting",
  providerfavoriteVideo: "/provider/favorite-videos",
  ActivateAccount: "/referral",
  referralRoleSelection: "/ref/:code/:channel/:userSlug?",
  referralSalesRep: "/referral/:slug/:channel?",
  AccountSettingsNew: "/provider/account-settings",
  Donation: "/provider/donation",
  MyAccountNew: "/provider/my-account-new",
  providerSupport: "/provider/support",
  providerCreateTicket: "/provider/ticket",
  providerTicketList: "/provider/ticket-list",
  providerTicketDetail: "/provider/ticket-detail",

  //frontend filter v2 screens
  searchContry: "/search-country",
  searchListCountry: "/search-country-list",
  topViewedVideos: "/topviewed-videos",

  // authentication
  billingProvider: "/provider/billing",
  billingsProvider: "/provider/billings",
  renewSubscription: "/provider/renew-subscription",
  changePlan: "/provider/change-plan",
  changePlanCard: "/provider/change-plan-card",
  credentialsProvider: "/provider/credentials",
  forgotPassword: "/provider/forgot-password",
  locationProvider: "/provider/location",
  providerLogin: "/provider/login",
  providerBase: "/provider",
  registerProvider: "/provider/register",
  thankYou: "/provider/thank-you",
  ThankYou: "/thank-you",
  verifyAccount: "/provider/verify-account",
  resetPassword: "/provider/reset-password/:id?",
  verifyEmail: "/provider/verify-email/:id?",
  addEvents: "/provider/add-events",
  cardIndex: "/provider/card",
  quickloginCardIndex: "/provider/payment",
  registerClient: "/provider/register-client",
  facilityInformation: "/provider/facility-information",
  nonProfitRegistration: "/provider/non-profit-registration",

  //Authentication [NewLoginScreens]
  registerStepAddress: "/provider/address",
  registerStepThree: "/provider/credential",
  notLicensedTextArea: "/provider/not-licensed-text-area",

  // client
  clientLogin: "/client/login",
  //clientIndex: "/client/dashboard",
  category: "/wellness-hub",
  psychopharmacologyVideos: "/psychopharmacology-videos",
  subCategoryClient: "/wellness-hub",
  groupCategoryClient: "/wellness-hub",
  subgroupCategoryClient: "/wellness-hub",
  clientdashboard: "/dashboard",

  // client-admin
  favoritevideo: "/client/favoritevideo",
  myaccount: "/client/my-account",
  homepage: "/client/dashboard",
  mycalender: "/client/calendar",
  mysubscription: "/client/subscription",
  notification: "/client/notification",
  payment: "/client/payment",
  providerdirectory: "/client/providerdirectory",
  wellneshub: "/client/wellnesshub",
  hub: "/hub",
  clientHub: "/client/hub",
  clientUpcomingEvents: "/client/upcomingevents",
  accountsettings: "/client/settings",
  support: "/client/support",
  preference: "/client/preference",
  walletClient: "/client/wallet",
  clientAnnouncements: "/client/announcements",
  referral: "/client/referral",
  referralHistory: "/client/referral/history",
  referralEmpty: "/client/referral-empty",
  clientBase: "/client",

  /* Client Version 2 screens */
  clientProviderDirectory: "/client/provider-directory",
  upcomingevents: "/client/upcoming-events",
  clientSettings: "/client/settings-v1",
  //User
  walletadmin: "/user/walletadmin",
  verifyAccountClient: "/client/verify-account",
  createTicket: "/client/ticket",
  ticketList: "/client/ticket-list",
  ticketDetail: "/client/ticket-detail",
  mysubscriptioncategoryfeed: "/client/categoryfeed",

  // frontend
  viewProfile: "/view-profile",
  filteredCountryFeed: "/filtered-country-feed",
  search: "/search",
  searchList: "/search-list",
  frontendIndex: "/index",
  searchTag: "/keywords",
  frontendReview: "/user-review/:id?/:share_type?",
  featuredWorldWide: "/front-end/featured-world-wide",
  // walletAdmin: "/provider/wallet-admin",
  mostLiked: "/most-liked",
  followingFeed: "/following-feed",
  homepageConcept: "/",
  // newHomepage: "/",
  // preview: "/preview",
  GlobalFeed: "/global-feed",
  localFeed: "/local-feed",
  nationalFeed: "/national-feed",
  viewAllFeed: "/view-all-feed",
  viewAllFeedForStream: "/view-all-feed/live-streams",
  providersReplyFeed: "/front-end/reply",
  twfeedprovider: "/live-stream",
  clientGoLive: "/client-live",
  goLiveSchedule: "/provider/create-worldwide-stream",
  twproviders: "/featured-providers",
  subCategoryFrontend: "/sub-category",
  providernewsale: "/joinHealingSky",
  bloglist: "/blog" /* /articles */,
  blogDetails: "/blog",
  blogFilter: "/blog-filter",
  providerVideo: "/video",
  videoEmbed: "/video/embed",
  errorinfo: "/error-404",
  twStream: "/tw-stream",
  mysubscriptionFollowers: "/subscription-followed-feeds",
  exploreVideos: "/explore-videos",
  NewViewProfile: "/new-view-profile",

  // navbar pages
  topCategories: "/top-categories",
  topEvents: "/top-events",
  topProviders: "/top-providers",
  topProvidersReview: "/top-providers-review",
  topVideos: "/top-videos",
  topVideosLiked: "/top-videos-liked",
  mostPopularEvents: "/most-popular-events",
  newEvents: "/new-events",
  todayEvents: "/today-events",
  upcomingEvents: "/upcoming-events",
  frontendCalendar: "/calendar",
  trendingEvents: "/trending-events",
  recommendEvents: "/recommended-events",
  newestEvents: "/newest-events",
  localRecommendations: "/local-recommendations",
  // test: "/test",
  about: "/about-us",
  commonSupport: "/support",
  contact: "/contact",
  menuListDetails: "/menu-list",
  masterDetails: "/master",

  /* What Healing Sky Does */
  connectingPatient: "/connecting-patient",
  digitalHub: "/digital-hub",
  diverseAudience: "/diverse-audience",
  // dynamicPages: "/dynamic-page",
  upcommingStreamWW: "/upcoming-stream",
  // videoSearchNew: "/videos",
  allVideo: "/videos",
  wellness: "/wellness-hub-new",
  currentlyLive: "/currently-live",

  /* Sales rep  */

  salesCategory: "/sales-category",
  salesBlog: "/sales-blog",
  /* Meeting rep  */

  meetingGroup: "/provider/meeting-group",
  meetingDetails: "/provider/meeting-details",
  meetingSelf: "/provider/meeting-self",
  meetingSelfDetails: "/provider/meeting-self-details",
  meetingScheduleStream: "/provider/meeting-schedule-stream",
  meetingSettings: "/provider/meeting-settings",
  meetingWaitingRoom: "/provider/meeting-waiting-room",
  meetingRoom: "/meeting-room",
  selfHelpSearch: "/self-help-search",
  selfHelpSearchState: "/self-help-search-state",
  selfHelpSearchStateCity: "/self-help-search-state-city",
  selfHelpSearchInperson: "/self-help-search-inperson",
  selfHelpSearchIndividual: "/self-help-search-individual",
  selfHelpSearchHybrid: "/self-help-search-hybrid",
  meeting: "/meeting",
  meetPassCode: "/meeting-passcode",
  meetNotify: "/meeting-notify",
  joinGoLive: "/join-golive",

  contactUs: "/contact-us",
  pricingProvider: "/pricing-provider",

  /* New screen */
  unclamieProfile: "/unclamie-profile",
  unclamieProfileRegister: "/unclaimed-profile-register",
  unclimieManuvalRegister: "/manuval-register",

  /* Worldwide Stream – playlist channel (no encrypted params) */
  worldwideStream: "/worldwide-stream",
};
